import axios from "axios";

export const sitesService = {
	getSites,
  getSite,
  createSite,
  updateSite,
  deleteSite,
  confirmDNS,
  getTemplateBlocks,
  saveTemplateBlocks,
  checkNewDomain,
  buyNewDomain,
  getFiles,
  getOneFile,
  getTemplates
	// generateReportOpenChechs,
  // generateReportClosedChechs,
  // generateReportFinancial
}

function getSites(data) {
	return axios.get(`/sites`, {params: data}).then((res) => {
		return res.data
	}).catch((err) => {
		return Promise.reject(err)
	})
}

function getSite(data) {
	return axios.get(`/sites/${data.storageZoneId}`, {}).then((res) => {
		return res.data
	}).catch((err) => {
		return Promise.reject(err)
	})
}

function createSite(data) {
  return axios.post('/sites', data).then(res => {
      return res
  }).catch((err) => {
      return Promise.reject(err)
  })
}

function updateSite(id, data, filePage) {
  return axios.put(`/sites/${id}`, data, {params: {path: filePage}} ).then(res => {
      return res
  }).catch((err) => {
      return Promise.reject(err)
  })
}

function getFiles(id) {
  return axios.get(`/sites/${id}/files` ).then(res => {
      return res
  }).catch((err) => {
      return Promise.reject(err)
  })
}
function getOneFile(data) {
  return axios.get(`/sites/${data.id}/files/single`, {params: {path: data.path}} ).then(res => {
      return res
  }).catch((err) => {
      return Promise.reject(err)
  })
}

function deleteSite(id) {
  return axios.delete(`/sites/${id}`, {} ).then(res => {
      return res
  }).catch((err) => {
      return Promise.reject(err)
  })
}

function confirmDNS(id) {
  return axios.post(`/sites/${id}/custom-domain/validate`, null).then(res => {
      return res
  }).catch((err) => {
      return Promise.reject(err)
  })
}

function getTemplateBlocks(data) {
  return axios.get('/templates/blocks', {params: data}).then(res => {
      return res
  }).catch((err) => {
      return Promise.reject(err)
  })
}
function saveTemplateBlocks(data) {
  return axios.post('/templates/blocks', data).then(res => {
      return res
  }).catch((err) => {
      return Promise.reject(err)
  })
}

function checkNewDomain(data) {
  return axios.get('/sites/domain/availability', {params: data}).then(res => {
      return res
  }).catch((err) => {
      return Promise.reject(err)
  })
}

function buyNewDomain(id, data) {
  return axios.post(`/sites/${id}/new-domain/buy`, data).then(res => {
      return res
  }).catch((err) => {
      return Promise.reject(err)
  })
}

function getTemplates(content = false) {
  return axios.get('/templates', {
    params: {
      with_content: content
    }
  }).then(res => {
      return res
  }).catch((err) => {
      return Promise.reject(err)
  })
}

// function generateReportClosedChechs(data) {
//   return axios.post('/reports/closed-checks', data).then(res => {
//       return res
//   }).catch((err) => {
//       return Promise.reject(err)
//   })
// }

// function generateReportFinancial(data) {
//   return axios.post('/reports/financial', data).then(res => {
//       return res
//   }).catch((err) => {
//       return Promise.reject(err)
//   })
// }
